import React, { useState } from 'react'
import {
  CNav,
  CNavItem,
  CNavLink,
  CContainer,
  CRow,
  CCol,
  CCard,
  CTable,
  CTableBody,
  CTableHeaderCell,
  CTableRow,
  CTableDataCell,
  CSpinner,
} from '@coreui/react'
import PatientInfoDisplay from './PatientInfoDisplay'

const ShowDemographics = ({ formData, diagnosis, patientDiagnosis, loading, setLoading }) => {
  const [activeTab, setActiveTab] = useState('personal')

  const userData = JSON.parse(localStorage.getItem('user'))
  const role = userData?.Role

  const renderTableRow = (label, value) => (
    <CTableRow>
      <CTableHeaderCell style={{ color: role === 'provider' ? 'white' : '' }}>
        <strong>{label}</strong>
      </CTableHeaderCell>
      <CTableDataCell style={{ color: role === 'provider' ? 'white' : '' }}>
        {value || 'N/A'}
      </CTableDataCell>
    </CTableRow>
  )

  return (
    <CContainer className="mt-2">
      {/* NAV */}
      <CNav variant="pills" className="justify-content-center mb-4 text-white">
        <CNavItem>
          <CNavLink
            style={{ color: role === 'provider' ? 'white' : '' }}
            active={activeTab === 'personal'}
            onClick={() => setActiveTab('personal')}
          >
            Personal Information
          </CNavLink>
        </CNavItem>

        <CNavItem>
          <CNavLink
            style={{ color: role === 'provider' ? 'white' : '' }}
            active={activeTab === 'contact'}
            onClick={() => setActiveTab('contact')}
          >
            Contact Information
          </CNavLink>
        </CNavItem>

        <CNavItem>
          <CNavLink
            style={{ color: role === 'provider' ? 'white' : '' }}
            active={activeTab === 'other'}
            onClick={() => setActiveTab('other')}
          >
            Practice Details
          </CNavLink>
        </CNavItem>
      </CNav>

      <CRow className="mb-3">
        <CCol>

          {/* ================= PERSONAL TAB ================= */}
          {activeTab === 'personal' &&
            (loading ? (
              <div className="d-flex justify-content-center align-items-center" style={{ height: '120px' }}>
                <CSpinner color="primary" />
              </div>
            ) : (
              <>
                <h3 style={{ color: role === 'provider' ? 'white' : '' }}>
                  {`${formData.FirstName} ${formData.MiddleName} ${formData.LastName}`}
                </h3>

                <CCard
                  className="p-2"
                  style={{
                    borderRadius: '1rem',
                    background: role === 'provider' ? '#191919' : '',
                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                    overflow: 'hidden',
                  }}
                >
                  <CTable>
                    <CTableBody style={{ background: role === 'provider' ? '#191919' : '' }}>
                      {renderTableRow('First Name', formData.FirstName)}
                      {renderTableRow('Middle Name', formData.MiddleName)}
                      {renderTableRow('Last Name', formData.LastName)}
                      {renderTableRow(
                        'Date of Birth',
                        formData.DOB ? new Date(formData.DOB).toLocaleDateString('en-US') : 'N/A'
                      )}
                      {renderTableRow('Gender', formData.Gender)}
                      {renderTableRow('Age', formData.Age)}
                      {renderTableRow(
                        'Diagnosis',
                        Array.isArray(patientDiagnosis) && patientDiagnosis.length > 0
                          ? patientDiagnosis.join(', ')
                          : 'N/A'
                      )}
                    </CTableBody>
                  </CTable>
                </CCard>
              </>
            ))}

          {/* ================= CONTACT TAB ================= */}
          {activeTab === 'contact' &&
            (loading ? (
              <div className="d-flex justify-content-center align-items-center" style={{ height: '120px' }}>
                <CSpinner color="primary" />
              </div>
            ) : (
              <CCard
                className="p-2"
                style={{
                  borderRadius: '1rem',
                  boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                  background: role === 'provider' ? '#191919' : '',
                }}
              >
                <h5
                  style={{
                    borderBottom: role === 'provider' ? '1px solid rgba(255, 255, 255, 0.15)' : '1px solid #ccc',
                    paddingBottom: '1rem',
                    color: role === 'provider' ? 'white' : '',
                  }}
                >
                  Contact Information</h5>

                <CTable>
                  <CTableBody>
                    {renderTableRow('Emergency Contact Name', formData.EmergencyName)}
                    {renderTableRow('Emergency Contact Phone', formData.EmergencyPhone)}
                  </CTableBody>
                </CTable>
              </CCard>
            ))}

          {/* ================= OTHER TAB ================= */}
          {activeTab === 'other' && (
            loading ? (
              <div className="d-flex justify-content-center align-items-center" style={{ height: '120px' }}>
                <CSpinner color="primary" />
              </div>
            ) : (
              <PatientInfoDisplay diagnosis={diagnosis} formData={formData} />
            )
          )}

        </CCol>
      </CRow>
    </CContainer>
  )
}

export default ShowDemographics